<!-- 开票申请单的退票信息 -->
<template>
  <el-form ref="form"
           size="medium"
           label-width="140px">
    <div class="medium"
         style="width: auto">
      <el-form-item label="是否当月发票:">
        <span>{{ form.is_current_month ? '当月发票' : '非当月发票' }}</span>
      </el-form-item>
      <el-form-item label="红冲发票附件:"
                    v-if="form.is_current_month === 0">
        <AttachedFileList :files="form.red_flush_attached_file"/>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import AttachedFileList from './AttachedFileList'

export default {
  components: {
    AttachedFileList
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
  }
}
</script>

<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/InvoiceReturnLayout.vue